import { useEffect } from 'react';
import { useMe } from '@/lib/auth';
import { bfocusInit, bfocusDestroy, bfocusEnabled } from '@/lib/bfocus';

// Launcher flutuante do bFocus — carregado APENAS no desktop. No mobile o widget
// NÃO é carregado (libera a tela); o suporte fica no item de menu "Suporte".
export function SupportWidget() {
  const { data: me } = useMe(true);

  useEffect(() => {
    if (!bfocusEnabled() || !me) return;
    // Não carrega o launcher flutuante no mobile.
    if (window.matchMedia('(max-width: 767px)').matches) return;
    bfocusInit(me);
    return () => bfocusDestroy();
  }, [me]);

  return null;
}
